/**
 * Acorta un texto si es demasiado largo, añadiendo puntos suspensivos al final.
 *
 * @param {string} text - El texto a acortar.
 * @param {number} maxLength - La longitud máxima del texto antes de acortarlo.
 * @returns {string} - El texto acortado con puntos suspensivos si es necesario.
 */
export const shortenText = (text, maxLength = 100) => {
  if (text.length <= maxLength) {
    return text;
  }

  const shortened = text.substring(0, maxLength);
  const lastSpaceIndex = shortened.lastIndexOf(" ");

  // Si no hay espacios en la cadena acortada, simplemente corta y añade "..."
  if (lastSpaceIndex === -1) {
    return shortened + "...";
  }

  return shortened.substring(0, lastSpaceIndex) + "...";
};
